<template>
  <Layout>
  <DsIslandsContainer>
    <DsIsland>
      <DsTitle>
        <span v-html="translate('goldkid-blank:title-name', kidParentData.kidData.firstName)" />
        <template #subtitle>
          <div class="caption-700">
            {{ translate('goldkid-blank:title-description') }}
          </div>
        </template>
      </DsTitle>
      <form @submit.prevent="nextPage">
        <PhoneInput ref="phoneInputRef" @pickContact="bindContact" :rules="rules" v-model="kidData.phone" :label="translate('goldkid-blank:phone')">
        </PhoneInput>
        <DsInformer status="warning"> {{ translate('goldkid-blank:phone-note') }}</DsInformer>
      </form>
    </DsIsland>
    <DsButtonBar sticky>
      <DsButton @click="nextPage" size="large">
          {{ translate('goldkid-blank:btn') }}
      </DsButton>
      <template #description>
        <div @click.prevent="openAgreement" v-html="translate('goldkid-blank:confirm-doc')"/>
      </template>
    </DsButtonBar>
    <!-- Submit -->
    <Otp v-if="isOtpActive" v-model="isOtpActive" />
    <DsAlert :visible="alertRef.server.value" layout="vertical">
      <template #title>
        <span v-html="alertRef.server.title" />
      </template>
      <template #description>
        <span v-html="alertRef.server.text" />
      </template>
      <DsButton type="ghost" size="large" @click="alertRef.server.value = false">
        OK
      </DsButton>
    </DsAlert>

    <DsAlert :visible="alertRef.invalid" layout="vertical">
      <template #title>
        {{ translate('alert:validation-title') }}
      </template>
      <template #description>
        <span v-html="translate('alert:validation-text')"></span>
      </template>
      <DsButton type="ghost" size="large" @click="alertRef.invalid = false">
        OK
      </DsButton>
    </DsAlert>
    <DsAlert :visible="alertRef.yourPhone" layout="vertical">
      <template #title>
        {{ translate('alert:your-phone-title', userData.firstName) }}
      </template>
      <template #description>
        {{ translate('alert:your-phone-text', kidParentData.kidData.firstName) }}
      </template>
      <DsButton type="ghost" size="large" @click="alertRef.yourPhone = false">
        OK
      </DsButton>
    </DsAlert>
  </DsIslandsContainer>
  </Layout>
</template>

<script setup>
import { DsIsland, DsTitle,DsIslandsContainer, DsInformer, DsButtonBar, DsButton, DsAlert } from '@ds/vue2'
import IsAvailablePickContact from '@/rules/IsAvailablePickContact'
import { KASPI } from '@/config'
import { eventBus } from 'kaspi.frontend/src/modules/eventBus/eventBus'
import { sendAnalyticEvent } from '@/helpers/sendAnalyticEvent'
import { getProperPhoneNumber } from './helpers'
import Inputmask from 'inputmask'
import Otp from '@/components/Otp/Otp'
import validPhoneLength from '@/validations/validPhoneLength'
import validPhoneOperator from '@/validations/validPhoneOperator'
import validPhoneNumber from '@/validations/validPhoneNumber'
import translate from "@/filters/translate.filter"
import PhoneInput from '@/components/ui/Input/PhoneInput.vue'

import { computed, onBeforeUnmount, onMounted, ref } from 'vue'
import useStore from '@/composables/useStore'
import useHeader from '@/composables/useHeader'
import Layout from '@/components/ui/Layout/Layout.vue'
const store = useStore()

const {setBackFn} = useHeader()
setBackFn(() => {
  setTimeout(() => {
    store.dispatch('goldkidProcess/component', 'start')
  },0)
})

const phoneInputRef = ref()
const rules = ref([
  x => Boolean(x) || translate('goldkid-blank:phone-required'),
  x => validPhoneNumber(x) || translate('goldkid-blank:phone-number'),
  x => validPhoneLength(x) || translate('goldkid-blank:phone-length'),
  (x) => validPhoneOperator(String(x)) || translate('goldkid-blank:phone-operator'),
])

const validatePhone = () => {
  const value = kidData.value.phone
  if (!value || !validPhoneNumber(value) || !validPhoneLength(value) || !validPhoneOperator(value)) return false
  return true
}

const analyticErrors =  ref([])
const isOtpActive =  ref(false)
const alertRef = ref({
  invalid: false,
  yourPhone: false,
  server: {
    value: false,
    title: '',
    text: ''
  }
})
const kidData = ref({
  phone: '',
  firstName: ''
})

const kidParentData = ref({
  parentData: {
    firstName: '',
    lastName: '',
    middleName: '',
    iin: '',
    phoneNumber: ''
  },
  kidData: {
    firstName: '',
    lastName: '',
    middleName: '',
    iin: ''
  }
})

const userData = computed(() => {
  return store.getters['goldkidProcess/userData']
})

const dataStep = async () => {
  const response = await store.dispatch('goldkidProcess/dataStep')

  kidParentData.value = { ...response?.data?.data }
  store.commit('goldkidProcess/setKidInfo', kidParentData.value.kidData)
}
const openAgreement = () => {
  if (!validate()) {
    return
  }
  saveKidData()
  store.dispatch('goldkidProcess/component', 'GoldkidAgreement')
}
// Заполнения массива ошибками валидации (вступает в качестве обработчика события)
const handleInputErrors = ({ message, fieldName }) => {
  analyticErrors.value.push({
    message,
    fieldName
  })
}

const bindContact = () => {
  sendAnalyticEvent('online_child_gold_contacts_open', {
    started_from: [store.getters['app/urlParams'].startedFrom],
    page_path: ['/bank/bpm/products/goldkids/goldkid'],
    external_message_id: [store.getters['goldkidProcess/pId']]
  })

  // pickContact callback handler
  window.goldkid_open_pick_contact_callback = (status, number) => {
    if (status === 'OK') {
      sendAnalyticEvent('online_child_gold_contacts_select', {
        started_from: [store.getters['app/urlParams'].startedFrom],
        page_path: ['/bank/bpm/products/goldkids/goldkid'],
        external_message_id: [store.getters['goldkidProcess/pId']]
      })
      kidData.value.phone = Inputmask.format(getProperPhoneNumber(number), { mask: '+7 (999) 999 99 99' })
    }
  }

  if ((new IsAvailablePickContact()).isSatisfiedBy(KASPI.mobapp)) {
    KASPI.mobapp.pickContact('goldkid_open_pick_contact_callback')
  }
}


const validate = () => {
  // function returns true if everything is ok
  if (!validatePhone()) {
    // Асинхронная отправка данных ошибки о валидации в амплитуду
    // Сработает после handleInputErrors
    setTimeout(() => {
      // Подготовка данных для отправки
      const fields = []
      const messages = []
      analyticErrors.value.forEach(({ fieldName, message }) => {
        fields.push(fieldName)
        messages.push(message)
      })

      if (analyticErrors.value.length) {
        sendAnalyticEvent('online_child_gold_validation_error', {
          started_from: [store.getters['app/urlParams'].startedFrom],
          stage: ['start'],
          page_path: ['/bank/bpm/products/goldkids/goldkid'],
          field: fields,
          error_text: messages,
          inner_source: ['online_child_gold_phone'],
          external_message_id: [store.getters['goldkidProcess/pId']]
        })
        analyticErrors.value = []
      }
    }, 0)

    if (phoneInputRef.value && kidData.value.phone) {
      const isValid = phoneInputRef.value.triggerValidation()
      if (!isValid) {
        return false
      }
    }
    alertRef.value.invalid = true
    return false
  }

  const userPhone = kidParentData.value.parentData.phoneNumber
  let kidPhone = kidData.value.phone.replace(/\+7/g, '')
  kidPhone = kidPhone.replace(/\D+/g, '')

  if (kidPhone === userPhone) {
    alertRef.value.yourPhone = true
    return false
  }

  return true
}

const saveKidData = () => {
  store.commit('goldkidProcess/setKidData', {
    ...kidData.value
  })
}
const nextPage = async () => {
  if (!validate()) {
    return
  }
  saveKidData()
  const data = {
    meta: store.getters['goldkidProcess/meta'],
    data: {
      kidPhoneNumber: kidData.value.phone
    }
  }
  eventBus.$emit('kaspiLoading', true)
  const response = await store.dispatch('goldkidProcess/processStep', data).catch(e => {
    store.dispatch('goldkidProcess/component', 'error')
  })
  // api call suceed, turning off loader
  eventBus.$emit('kaspiLoading', false)
  const component = response?.data?.data?.component

  if (component === 'otp') {
    isOtpActive.value = true
  }

  // Обработка ошибки валидации с сервера
  if (response?.data?.result.toLowerCase?.() === 'error') {
    alertRef.value.server = {
      value: true,
      title: response.data.data.title,
      text: response.data.data.message
    }
  }

  if (component && component !== 'otp') {
    store.dispatch('goldkidProcess/component', component)
  }
}

onMounted(async() => {
    await dataStep()
    eventBus.$emit('kaspiLoading', false)

    sendAnalyticEvent('online_child_gold_phone', {
      started_from: [store.getters['app/urlParams'].startedFrom],
      stage: ['start'],
      page_path: ['/bank/bpm/products/goldkids/goldkid'],
      external_message_id: [store.getters['goldkidProcess/pId']]
    })
    // KAFKA LOGGER
    store.dispatch('goldkidProcess/logEventToKafka', {
      ver: 1,
      usrId: store.getters['goldkidProcess/userData']?.userId,
      evt: 'gold_kid_events',
      act: 'online_child_gold_phone'
    })
    // returning data after signing agreement
    const kidDataServer = store.getters['goldkidProcess/kidData']
    if (kidDataServer?.phone) {
      kidData.value = { ...kidDataServer }
    }
    const kidDataFromGetters = store.getters['goldkidProcess/kidData']
    if (kidDataFromGetters.phone) {
      kidData.value.phone = kidDataFromGetters.phone
    }
    if (kidDataFromGetters.firstName) {
      kidData.value.firstName = kidDataFromGetters.firstName
    }
})

onBeforeUnmount(() => {
  sendAnalyticEvent('online_child_gold_phone', {
    started_from: [store.getters['app/urlParams'].startedFrom],
    stage: ['finish'],
    page_path: ['/bank/bpm/products/goldkids/goldkid'],
    external_message_id: [store.getters['goldkidProcess/pId']]
  })
})
</script>
